import { Locales } from '@ratehub/base-ui';
import { PATHS } from '@ratehub/web-components';

import createMortgageAgentDetailsStaticProps from '../functions/createMortgageAgentDetailsStaticProps';
import withEnglishLocale from '../functions/withEnglishLocale';
import MortgageAgentDetailsPage from '../components/MortgageAgentDetailsPage';


const { getStaticPaths, getStaticProps } = createMortgageAgentDetailsStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'mtgAgentDetailsEN',
    path: PATHS.AGENT_DETAILS,
});

export default withEnglishLocale(MortgageAgentDetailsPage);
export { getStaticPaths, getStaticProps };

